export default __webpack_public_path__ + "static/media/blog-five3.9b1fdd3c.jpg";